import { render } from "./FreelancersView.vue?vue&type=template&id=f7675c86"
import script from "./FreelancersView.vue?vue&type=script&lang=js"
export * from "./FreelancersView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__